var classes = {"overlayVideoWrapper":"P6Dsh","overlayVideoGrid":"lsW0V","overlayVideoContainer":"_97HsA","overlayVideoCloseIcon":"lULlf"};

export { classes as default };
